<span #stickyPopover="stickyPopover"
      [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="'outside'"
      [animation]="false"
      popoverClass='context-menu-popover'
      container="body"
      triggers="manual"
      placement="auto">
</span>

<ng-template #popTitle>
  <i class="fa-light fa-magnifying-glass me-1"></i>Search in {{raDec[0] | raHms}} {{raDec[1] | decDms}}
</ng-template>

<ng-template #popContent>
  <div class="d-flex align-items-center justify-content-around">
    <div *ngFor="let search of searches" class="p-1 bd-highlight">
      <img [src]="search.icon"
           (click)="openSearchInNewTab(search.url)"
           style="cursor: pointer"
           placement="top"
           [ngbTooltip]="search.tooltip">
    </div>
  </div>
</ng-template>
